import React,{useEffect} from 'react'
import Header from './Header'
import {Link,useHistory} from "react-router-dom";
import {auth} from './firebase';
import { useStateValue } from './StateProvider';
import './Annonce'
import Annonce from './Annonce';
import Favoris from './Favoris';
import Reglages from './Reglages';
function Account() {
        var link=[];
        const a =window.location.href;
        const b =new URLSearchParams(a)
        for(const [key,value] of b){
            link.push(value);
        }
    const[{user},dispatch]=useStateValue();
    useEffect (()=>{
        auth.onAuthStateChanged(authUser=>{
            if(authUser){
                dispatch({
                    type:'SET_USER',
                    user: authUser
                })
            }else{
                dispatch({
                    type:'SET_USER',
                    user: null
                })
            }
        })
    },[])
    if(user){
        if(link[0]=='Mes_annonces'){
            return(<div>
                <Header/>
                <Annonce/>
            </div>)
        }else if(link[0]=='Mes_favoris'){
            return(<div>
                <Header/>
                <Favoris/>
            </div>)
        }else if(link[0]=='Chat'){
            return(<div>
                <Header/>
                <h1>{user?'eqtjetj':'You need to Login'}</h1>
            </div>)
        }else if(link[0]=='Réglages'){
            return(<div>
                <Header/>
                <Reglages/>
            </div>)
        }else{
            return(<div>
                <Header/>
                <h1>{user?'o1og':'You need to Login'}</h1>
            </div>)
        }
    }else{
        return null
    }
}

export default Account
